import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot} from '@angular/router';
import {LocalStorageService} from '@dcp/configurator';
import {AbstractLocalStorageService} from '../common/abstract-local-storage.service';

const LOCAL_STORAGE_REQUIRED_FLOWS = 'userRegistrationConfigRequiredFlows';
const DEFAULT_REQUIRED_FLOWS = 'b2b,b2i';

@Injectable({
  providedIn: 'root',
})
export class UserRegistrationConfigService extends AbstractLocalStorageService {
  constructor(protected localStorageService: LocalStorageService, protected activatedRoute: ActivatedRoute) {
    super(localStorageService);
    this.setLocalStorageKey(LOCAL_STORAGE_REQUIRED_FLOWS);
  }

  public fetchConfigFromUrl(activatedRouteSnapshot?: ActivatedRouteSnapshot) {
    if (!activatedRouteSnapshot) {
      activatedRouteSnapshot = this.activatedRoute.snapshot;
    }
    const queryParam = activatedRouteSnapshot.queryParamMap.get('requiredRegistration');
    this.currentValue = queryParam?.length ? queryParam : DEFAULT_REQUIRED_FLOWS;
    this.setStorageValue(this.currentValue);
  }

  public resetConfig(): void {
    this.currentValue = DEFAULT_REQUIRED_FLOWS;
    this.resetStorageValue();
  }
}
